export default {
  searchBox: (isError: boolean) =>
    [
      'box-border',
      'h-auto',
      'max-w-screen-2xl',
      'flex-row',
      'items-center',
      'rounded-full',
      'bg-background',
      'hidden',
      'lg:flex',
      isError ? 'mb-3' : ''
    ].join(' '),

  floatingLabel: [
    'absolute',
    'left-4',
    'top-4',
    'origin-[0]',
    '-translate-y-4',
    'font-primary',
    'font-normal',
    'cursor-text',
    'scale-90',
    'transform',
    'text-b-base',
    'whitespace-nowrap',
    'text-neutral-60',
    'duration-300',
    'peer-placeholder-shown:translate-y-0',
    'peer-placeholder-shown:scale-90',
    'peer-focus:-translate-y-4',
    'peer-focus:scale-90',
    'peer-focus:text-neutral-60',
    'w-full'
  ].join(' '),

  dateLabel: [
    'absolute',
    'left-4',
    'top-4',
    'origin-[0]',
    '-translate-y-4',
    'font-primary',
    'font-normal',
    'scale-90',
    'text-b-base',
    'whitespace-nowrap',
    'text-neutral-60',
    'duration-300',
    'peer-placeholder-shown:translate-y-0',
    'peer-placeholder-shown:scale-90',
    'peer-focus:cursor-none',
    'w-full',
    'cursor-pointer'
  ].join(' '),

  textBox: (showErrorMessage: boolean | undefined, id: string): string =>
    [
      'text-primary',
      'peer',
      id === 'NUMBER_OF_SLEEPING_ROOMS' ? 'w-[-webkit-fill-available] w-[-moz-available]' : 'w-full',
      'pb-2',
      'pl-10',
      'pr-4',
      'pt-6',
      'border',
      'border-solid',
      showErrorMessage ? 'border-danger-50' : 'border-r-0 border-neutral-30',
      'text-b-base',
      'font-normal',
      'placeholder-transparent',
      'focus:outline-none',
      id === 'EVENT_START_DATE' || id === 'EVENT_END_DATE' ? 'caret-transparent' : ''
    ].join(' '),

  mobileTextBox: (showErrorMessage: boolean | undefined): string =>
    [
      'text-primary',
      'text-b-base',
      'p-1',
      'pl-10',
      'w-full',
      'font-normal',
      'rounded-lg',
      'border',
      'border-solid',
      showErrorMessage ? 'border-danger-50' : 'border-neutral-40',
      'focus:outline-none'
    ].join(' '),

  mobileSearchBox: [
    'flex',
    'items-start',
    'text-primary',
    'text-b-base',
    'p-2.5',
    'pl-12',
    'w-full',
    'font-normal',
    'box-border',
    'flex-row',
    'truncate',
    'items-center',
    'rounded-full',
    'border',
    'border-solid',
    'border-neutral-30',
    'bg-background'
  ].join(' ')
};
